<template>
  <div class="app-wrapper"
       :class="{hideSidebar:!sidebar.opened}">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar v-if="!breadcrumbShow"></navbar>
      <!-- <tags-view></tags-view> -->
      <breadcrumb class="breadcrumb-container" v-show="!breadcrumbShow"></breadcrumb>
      <app-main></app-main>
      <out-drawer></out-drawer>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from '@/backend/pages/layout/components/index'
import Breadcrumb from "@/components/Breadcrumb/index";
import pageCached from '@/backend/pages/layout/components/pageCached.js'
import outDrawer from "@/components/aiAds/outDrawer.vue";
export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    Breadcrumb,
    outDrawer
  },
  mixins: [pageCached],
  computed: {
    sidebar () {
      return this.$store.state.app.sidebar
    },
    breadcrumbShow() {
			// google Ads 账户管理页面不要面包屑导航
      let isShow = ['accountManagement','addAdSeries','addAdGroup','addAdVertising','addAdKeyword'].some(item => this.$route.path.indexOf(item) != -1);
			return isShow && this.$route.path.indexOf('googleAds') != -1;
		},
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/backend/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
